module.exports = __webpack_public_path__ + "static/media/room-4.f5d3df15.jpg";